"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deduplicate = exports.chunk = exports.removeElement = exports.range = exports.moveElement = exports.insertElements = exports.calculateStep = void 0;
const errors_1 = require("./errors");
const calculateStep = (difference, step) => {
    if (typeof step === 'number') {
        if ((step > 0 && difference < 0) || (step < 0 && difference > 0)) {
            throw (0, errors_1.createError)('CalculateStepError', `step: ${step}, difference: ${difference}`);
        }
        return step;
    }
    if (difference > 0) {
        return 1;
    }
    return -1;
};
exports.calculateStep = calculateStep;
/**
 * Returns a new array with the elements at `index` inserted.
 */
const insertElements = (arr, index, ...items) => {
    if (index < 0 || index > arr.length) {
        throw new Error(`index is out of bounds: ${index}`);
    }
    const newArr = [...arr];
    newArr.splice(index, 0, ...items);
    return newArr;
};
exports.insertElements = insertElements;
/**
 * Returns a new array moving the element at `fromIndex` to `toIndex`.
 */
const moveElement = (arr, fromIndex, toIndex) => {
    if (fromIndex < 0 || fromIndex >= arr.length) {
        throw new Error(`fromIndex is out of bounds: ${fromIndex}`);
    }
    if (toIndex < 0 || toIndex >= arr.length) {
        throw new Error(`toIndex is out of bounds: ${toIndex}`);
    }
    const element = arr[fromIndex];
    const newArr = [...arr];
    newArr.splice(fromIndex, 1);
    newArr.splice(toIndex, 0, element);
    return newArr;
};
exports.moveElement = moveElement;
/**
 * Range function with configurable step and non-inclusive `end` value.
 */
const range = (start, end, step) => {
    if (step === 0) {
        throw (0, errors_1.createError)('RangeStepError', 'Step cannot be 0');
    }
    const difference = end - start;
    if (typeof step === 'number' && ((step > 0 && difference < 0) || (step < 0 && difference > 0))) {
        throw (0, errors_1.createError)('RangeStepError', `The step ${step} is not compatible with the range ${start} to ${end}. You can not reach the end from the current start using that step polarity.`);
    }
    const calculatedStep = (0, exports.calculateStep)(difference, step);
    const length = Math.floor(difference / calculatedStep);
    return Array.from({ length }, (_, i) => start + i * calculatedStep);
};
exports.range = range;
/**
 * Returns a new array with the element at `index` removed.
 */
const removeElement = (arr, index, deleteCount = 1) => {
    if (index < 0 || index >= arr.length) {
        throw new Error(`index is out of bounds: ${index}`);
    }
    const newArr = [...arr];
    newArr.splice(index, deleteCount);
    return newArr;
};
exports.removeElement = removeElement;
const chunk = (arr, size) => Array.from({ length: Math.ceil(arr.length / size) }, (_, i) => arr.slice(i * size, (i + 1) * size));
exports.chunk = chunk;
const deduplicate = (arr) => [...new Set(arr)];
exports.deduplicate = deduplicate;
